import React,{useState,useEffect} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import {Link} from 'react-router-dom';
import Logo from './ui/Logo';
import {FiChevronDown,FiMenu,FiX} from 'react-icons/fi';

const Header = () => {
  const [scrolled,setScrolled] = useState(false);
  const [dropdownOpen,setDropdownOpen] = useState(false);
  const [mobileMenuOpen,setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll',handleScroll);
    return () => window.removeEventListener('scroll',handleScroll);
  },[]);

  const businesses = ['Consulting','Mobility','Capital','Learn'];

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-700 ${scrolled ? 'bg-brand-primary/98 backdrop-blur-xl border-b border-brand-secondary/30 shadow-2xl' : 'bg-transparent'}`} >
      {/* Main Navigation Container */}
      <div className={`transition-all duration-700 ${scrolled ? 'py-4' : 'py-8 md:py-10'}`}>
        <div className="container mx-auto px-6 md:px-12 flex justify-between items-center">
          {/* Discreet but clearly readable header logo */}
          <Link to="/" className="z-50 relative group flex items-center" aria-label="Home">
            <Logo className="h-7 md:h-9 lg:h-10 w-auto transition-transform duration-500 group-hover:scale-105" />
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-14 text-[13px] lg:text-[14px] tracking-[0.25em] uppercase font-semibold text-white">
            <div 
              className="relative group" 
              onMouseEnter={() => setDropdownOpen(true)} 
              onMouseLeave={() => setDropdownOpen(false)} 
            >
              <button className="flex items-center space-x-2 hover:text-brand-accent transition-colors py-2">
                <span>Businesses</span>
                <FiChevronDown className={`transition-transform duration-500 ${dropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              <AnimatePresence>
                {dropdownOpen && (
                  <motion.div 
                    initial={{opacity: 0,y: 15}} 
                    animate={{opacity: 1,y: 0}} 
                    exit={{opacity: 0,y: 10}} 
                    transition={{duration: 0.3,ease: "easeOut"}} 
                    className="absolute top-full left-0 mt-4 w-64 bg-brand-primary border border-brand-secondary/40 shadow-[0_20px_50px_rgba(0,0,0,0.5)] rounded-sm overflow-hidden" 
                  >
                    {businesses.map((biz) => (
                      <Link 
                        key={biz} 
                        to={`#${biz.toLowerCase()}`} 
                        className="block px-8 py-5 hover:bg-brand-secondary/20 hover:text-brand-accent transition-colors border-b border-brand-secondary/10 last:border-0 text-[12px] tracking-widest" 
                      >
                        EPOQ {biz}
                      </Link>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <a href="#about" className="hover:text-brand-accent transition-colors">About</a>
            <a href="#perspective" className="hover:text-brand-accent transition-colors">Perspective</a>
            <a href="#contact" className="hover:text-brand-accent transition-colors border border-brand-secondary/60 px-8 py-3 hover:border-brand-accent hover:bg-brand-accent/5 transition-all duration-300">Contact</a>
          </nav>

          <button className="md:hidden z-50 text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} >
            {mobileMenuOpen ? <FiX size={32} /> : <FiMenu size={32} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div 
            initial={{opacity: 0,x: '100%'}} 
            animate={{opacity: 1,x: 0}} 
            exit={{opacity: 0,x: '100%'}} 
            transition={{type: 'tween',duration: 0.5,ease: [0.22,1,0.36,1]}} 
            className="fixed inset-0 w-full h-screen bg-brand-primary flex flex-col pt-32 px-10 md:hidden z-40" 
          >
            <div className="flex flex-col space-y-10 text-3xl font-display font-light">
              <div className="text-brand-accent text-[11px] tracking-[0.4em] uppercase mb-2 font-bold">Businesses</div>
              {businesses.map((biz) => (
                <Link 
                  key={biz} 
                  to={`#${biz.toLowerCase()}`} 
                  onClick={() => setMobileMenuOpen(false)} 
                  className="pl-6 border-l-2 border-brand-secondary/30 hover:border-brand-accent hover:text-brand-accent transition-all" 
                >
                  EPOQ {biz}
                </Link>
              ))}
              <div className="h-px w-full bg-brand-secondary/20 my-4"></div>
              <a href="#about" onClick={() => setMobileMenuOpen(false)} className="hover:text-brand-accent">About</a>
              <a href="#perspective" onClick={() => setMobileMenuOpen(false)} className="hover:text-brand-accent">Perspective</a>
              <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="hover:text-brand-accent">Contact</a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;